import { createPremiumModule } from '@wix/premium-fed-sdk/@premium-module';
import { NetworkIssue, TechnicalIssue, RateLimit, NoRecommendations, NoPermissionsBlock } from '../components/Errors';
import { DomainInsight, AiInsightsModal } from '../components/Insight';
import SearchBar from '../components/SearchBar';
import SearchRecommendationList from '../components/SearchRecommendation';
import { TldPromotions } from '../components/TldPromotions';
import { TldPromotionsList } from '../components/TldPromotions/TldPromotionsList';
import { TldAlternatives } from '../components/TldAlternatives';
import { ActionsExtension, DomainSearchSuiteBIExtension, DomainSearchSuiteStoreExtension, DomainSearchSuiteTranslationsExtension } from './extensions';
import { Status } from './extensions/Actions/components';
import { ModalsProvider } from './ModalsProvider';
import { EmptyQueryStatus } from '../components/EmptyQueryStatus';
import { StatusesCustomComponentsExtension } from './extensions/StatusesCustomComponentsExtension';
import { DomainNameError } from './extensions/Actions/components/Statuses/DomainNameErrors';
import { urlRecoveryExtension } from '@wix/core-domain-search';
export const DomainSearchSuiteModule = createPremiumModule('domainSearchSuite', [DomainSearchSuiteTranslationsExtension, ActionsExtension, StatusesCustomComponentsExtension, DomainSearchSuiteBIExtension, DomainSearchSuiteStoreExtension, urlRecoveryExtension], () => ({
  SDK: {
    Components: {
      SearchRecommendationList,
      DomainSearchBar: SearchBar,
      TldPromotions,
      TldPromotionsList,
      TldAlternatives,
      DomainInsight,
      AiInsightsModal,
      Status,
      EmptyQueryStatus,
      NetworkIssue,
      TechnicalIssue,
      RateLimit,
      NoRecommendations,
      NoPermissionsBlock,
      ModalsProvider,
      DomainNameError
    }
  }
}));
//# sourceMappingURL=domainSearchSuite.module.js.map